// src\pages\ResetPassword.js

import React, { useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../services/api";

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

export default function ResetPassword() {
  const q = useQuery();
  const prefillEmail = q.get("email") || "";
  const [email, setEmail] = useState(prefillEmail);
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [notice, setNotice] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setNotice("");

    if (password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }

    setLoading(true);
    try {
      // POST /auth/reset-password  { email, code, password }
      await api.post("/auth/reset-password", { email, code, password });
      setNotice("Password reset successfully. You can log in now.");
      setTimeout(() => navigate("/login"), 1200);
    } catch (err) {
      const msg =
        err?.response?.data?.detail ||
        err?.message ||
        "Unable to reset password. Please try again.";
      setError(
        typeof msg === "string"
          ? msg
          : "Unable to reset password. Please verify your code and try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-form-container">
      <h1>Reset password</h1>
      <p>Enter the 6-digit code we emailed you and choose a new password.</p>

      <form onSubmit={submit} className="auth-form">
        <label htmlFor="email">Email</label>
        <input
          id="email"
          type="email"
          required
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={loading}
        />

        <label htmlFor="code">Reset code</label>
        <input
          id="code"
          type="text"
          inputMode="numeric"
          pattern="\d{6}"
          placeholder="123456"
          required
          value={code}
          onChange={(e) => setCode(e.target.value.trim())}
          disabled={loading}
        />

        <label htmlFor="password">New password</label>
        <input
          id="password"
          type="password"
          required
          minLength={8}
          autoComplete="new-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={loading}
        />

        <label htmlFor="confirm">Confirm new password</label>
        <input
          id="confirm"
          type="password"
          required
          minLength={8}
          autoComplete="new-password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          disabled={loading}
        />

        <button className="primary-btn" type="submit" disabled={loading}>
          {loading ? "Resetting…" : "Reset password"}
        </button>
      </form>

      {notice && <p className="success-message" role="status">{notice}</p>}
      {error && <p className="error-message" role="alert">{error}</p>}

      <div style={{ marginTop: 12 }}>
        <button className="link-btn" onClick={() => navigate("/forgot-password")}>
          Didn’t get a code? Resend
        </button>
      </div>
    </div>
  );
}
